export const ACCOUNTS_FETCH = 'ACCOUNTS_FETCH';
export const ACCOUNTS_FETCH_ALL = 'ACCOUNTS_FETCH_ALL';
export const ACCOUNTS_IS_FETCING = 'ACCOUNTS_IS_FETCING';
export const ACCOUNTS_API = 'accounts';
export const ACCOUNT_EDIT = 'ACCOUNT_EDIT';
export const ACCOUNT_SAVE = 'ACCOUNT_SAVE';
export const ACCOUNT_FILTER = 'ACCOUNT_FILTER';
export const SET_ACCOUNT_PROFILE = 'SET_ACCOUNT_PROFILE';
export const SET_ACCOUNT_IB = 'SET_ACCOUNT_IB';
export const SET_ACCOUNT_CLIENT = 'SET_ACCOUNT_CLIENT';



// WEBPACK FOOTER //
// ./src/constants/accounts.js